import {ISearchCondition} from '../../../../../AppSearches/types/filters';

export const isFilterChanged = (
    currConditions: ISearchCondition[],
    prevConditions: ISearchCondition[]
): boolean => {
    if (currConditions.length !== prevConditions.length) {
        return true;
    }

    return currConditions.some((curr, index) => {
        const prev = prevConditions[index];
        const currValues = curr.values ?? [];
        const prevValues = prev.values ?? [];

        const sameOperator = curr.operator === prev.operator;
        const sameValues =
            currValues.length === prevValues.length &&
            currValues.every(v => prevValues.includes(v));

        return !sameOperator || !sameValues;
    });
};
